import { Modal } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { modalGrey } from 'styles/Colors';

export const ModalContent = styled.div`
  padding: 19px 24px 24px;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

export const Controls = styled.div`
  padding: 8px 16px 20px;
  background-color: ${modalGrey};
  border-radius: 4px;
  margin-bottom: 32px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const InfoWrapper = styled.div`
  padding: 12px;
  background-color: rgba(224, 224, 224, 0.05);
  color: #7b7b7b;
  display: flex;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  font-family: Lato;
  font-size: 13px;
  line-height: 18.2px;
  display: flex;
  gap: 8px;

  p {
    margin-bottom: 0;
  }
`;

export const ControlsInfo = styled.div`
  font-size: 13px;
  line-height: 18.2px;
  color: #717171;
  margin-bottom: 10px;
`;

export const StyledModal = styled((props) => <Modal {...props} />)`
  div[class*='-btnContainer-'] {
    justify-content: center;
  }
`;
